import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PreferenzaAmministratore } from 'src/app/models/preferenza-amministratore';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit-preferenza-amministratore',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditPreferenzaAmministratoreComponent extends BaseEditForm implements OnInit {

  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditPreferenzaAmministratoreComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: PreferenzaAmministratore,
  ) {
    super();
  }

  ngOnInit() {
    this.form = this.fb.group({
      altro_soggetto: [this.data?.altro_soggetto, Validators.required],
      compagnia: [this.data?.compagnia, Validators.required],
      incaricato: [this.data?.incaricato, Validators.required],
    });
  }

}
